import React, { useContext, useEffect, useState } from 'react'
import AccessSuccessModal from '../../../components/modal/submit-success-modal'
import { Link, useNavigate, useParams } from 'react-router-dom'
import * as yup from 'yup'
import { forgotPassword } from '../../../utils/images/imagepath'
import { ApiServiceContext } from '../../../utils/shared.module'
import { useDispatch, useSelector } from 'react-redux'
import {
  SpecialCharacters,
  end_points,
  lowerCase,
  upperCase,
} from '../../../services/core.index'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import CryptoJS from 'crypto-js'

const passwordSchemaschema = yup.object().shape({
  new_password: yup.string().required('Enter new password').trim(),
  confirm_new_password: yup
    .string()
    .required('Enter confirm password')
    .oneOf([yup.ref('new_password')], 'Password does not match'),
})

const ResetPassword = () => {
  const { token } = useParams()
  const navigate = useNavigate()
  const layoutsettings = useSelector((state: any) => state?.layoutsettings)
  const { postData } = useContext(ApiServiceContext)
  const [showModal, setShowModal] = useState(false)
  const [eyenewpwd, setEyenewpwd] = useState(true)
  const [eyeconfirm, setEyeconfirm] = useState(true)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [encDatas, setencDatas] = useState<any>('')

  const onEyeClicknewPwd = () => setEyenewpwd(!eyenewpwd)
  const onEyeClickconfiirm = () => setEyeconfirm(!eyeconfirm)

  const {
    handleSubmit: changePasswordForm,
    control: changePasswordFormControl,
    formState: { errors: changePasswordFormErrors },
    clearErrors: clearChangePasswordForm,
    reset: changePasswordFormReset,
  } = useForm({
    resolver: yupResolver(passwordSchemaschema),
    defaultValues: {},
  })

  const submitchangePswdForm = async (data: any) => {
    const payload = {
      password: data?.new_password,
      confirm_password: data?.confirm_new_password,
    }
    try {
      const urls = `${end_points.resetPassword.url}/${token}`
      const response = await postData(urls, payload)
      if (response.status == 200) {
        setShowModal(true)
      } else {
        setError(true)
        setErrorMessage(response.data.errors[0].msg)
        setShowModal(false)
      }
    } catch (e) {}
  }

  const onOkayModal = () => navigate('/auth/login')

  // const decryption = async (data: string) => {
  //   try {
  //     if (error) setError(false)
  //     const secretKey: any = 'M5nZ3jkHvcst5HPvEMhQSqrzyhD94Iq6njIi/dxshr0='
  //     const ivHex = data.substring(0, 32) // 16 bytes in Hex = 32 characters
  //     const ciphertextHex = data.substring(32) // The rest is ciphertext
  //     const iv = CryptoJS.enc.Hex.parse(ivHex)
  //     const ciphertext = CryptoJS.enc.Hex.parse(ciphertextHex)

  //     const decrypted = CryptoJS.AES.decrypt(
  //       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //       // @ts-expect-error
  //       { ciphertext },
  //       CryptoJS.enc.Base64.parse(secretKey),
  //       { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }, // Using the same mode and padding
  //     )
  //     let datas = decrypted.toString(CryptoJS.enc.Utf8)
  //     if (typeof datas === 'string') {
  //       datas = JSON.parse(datas)
  //       if (typeof datas === 'object') {
  //         setencDatas(datas)
  //       }
  //     }
  //   } catch (e: any) {
  //     setError(true)
  //     setErrorMessage('Invalid reset details !')
  //   }
  // }

  // useEffect(() => {
  //   alert();
  //   if (typeof token === 'string') {
  //     if (error) setError(false)
  //     decryption(token)
  //   } else {
  //     setError(true)
  //     setErrorMessage('Invalid reset token !')
  //   }
  // }, [token])

  return (
    <>
      <div className='loginbox'>
        <div className='login-right'>
          <div className='login-right-wrap'>
            <div className='login-header'>
              <h1>{layoutsettings?.application_title || 'CRM'}</h1>
              <h4>
                Reset Password <img src={forgotPassword} alt='img' />
              </h4>
              <p className='account-subtitle'>
                {encDatas && Object.keys(encDatas).length && (
                  <>
                    for{' '}
                    <span className='font-bold'>{encDatas?.email || ''}</span>
                  </>
                )}
              </p>
            </div>
            {/* Form */}
            <form onSubmit={changePasswordForm(submitchangePswdForm)}>
              <div className='col-lg-12 col-md-12'>
                <div className='form-wrap'>
                  <label className='col-form-label'>New Password</label>
                  <div className='pass-group'>
                    <Controller
                      name='new_password'
                      control={changePasswordFormControl}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control pass-inputs  ${
                            changePasswordFormErrors?.new_password
                              ? 'error-input'
                              : ''
                          }`}
                          type={eyenewpwd ? 'password' : 'text'}
                          value={value}
                          onChange={onChange}
                          autoComplete='false'
                        />
                      )}
                      defaultValue=''
                    />{' '}
                    <span
                      onClick={onEyeClicknewPwd}
                      className={`ti toggle-passwords ${
                        eyenewpwd ? 'ti-eye-off' : 'ti-eye'
                      }`}
                    />
                  </div>
                  <small className='text-danger'>
                    {changePasswordFormErrors?.new_password?.message}
                  </small>
                </div>
              </div>
              <div className='col-lg-12 col-md-12'>
                <div className='form-wrap'>
                  <label className='col-form-label'>Confirm New Password</label>
                  <div className='pass-group'>
                    <Controller
                      name='confirm_new_password'
                      control={changePasswordFormControl}
                      render={({ field: { value, onChange } }) => (
                        <input
                          className={`form-control pass-inputnew  ${
                            changePasswordFormErrors?.confirm_new_password
                              ? 'error-input'
                              : ''
                          }`}
                          type={eyeconfirm ? 'password' : 'text'}
                          value={value}
                          onChange={onChange}
                          autoComplete='false'
                        />
                      )}
                      defaultValue=''
                    />{' '}
                    <span
                      onClick={onEyeClickconfiirm}
                      className={`ti toggle-passwordnew ${
                        eyeconfirm ? 'ti-eye-off' : 'ti-eye'
                      }`}
                    />
                  </div>
                  <small className='text-danger'>
                    {changePasswordFormErrors?.confirm_new_password?.message}
                  </small>
                </div>
              </div>
              <div className='form-wrap mb-0'>
                <button
                  className='btn btn-primary btn-block mb-3'
                  type='submit'
                >
                  Set New Password
                </button>
                <Link
                  to='/auth/login'
                  className='text-primary d-block text-center'
                >
                  <i className='ti ti-chevron-left ms-2' /> Back to log in
                </Link>
              </div>
            </form>
            {/* /Form */}
          </div>
        </div>
        {error && (
          <div className='alert alert-danger' role='alert'>
            {errorMessage}
          </div>
        )}
      </div>
      <AccessSuccessModal
        setShowModal={setShowModal}
        showModal={showModal}
        content='Your password has been successfully reset.'
        title='Password reset'
        email={false}
        onOk={onOkayModal}
      />
    </>
  )
}

export default ResetPassword
